import { request } from 'src/utils/requestV2'

export type Config = {
  hash: string
  config: Dictionary<unknown>
}

const globalConfigServiceUrl = '/config/api/global'

export const getConfig = async () => {
  return await request
    .get<Config>(globalConfigServiceUrl)
    .then((res) => res.data)
}

export const saveConfig = async (data: Dictionary<unknown>) => {
  return await request
    .post<Config>(globalConfigServiceUrl, data)
    .then((res) => res.data)
}

export const clear = async () => {
  await request.delete(globalConfigServiceUrl)
}

export const getHash = async () => {
  return await request
    .get<{ hash: string }>(globalConfigServiceUrl)
    .then((res) => res.data)
}
